import { render } from "./historyCardMobile.vue?vue&type=template&id=50b282cf&scoped=true"
import script from "./historyCardMobile.vue?vue&type=script&lang=js"
export * from "./historyCardMobile.vue?vue&type=script&lang=js"

import "./historyCardMobile.vue?vue&type=style&index=0&id=50b282cf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50b282cf"]])

export default __exports__